import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ANNOUNCEMENTS } from "../data/content";

function useLaunchDeadline() {
  const [deadline] = useState(() => {
    const KEY = "yaba_ss26_launch_deadline";
    if (typeof window === "undefined") return Date.now() + 14 * 864e5;
    const stored = window.localStorage.getItem(KEY);
    if (stored) return Number(stored);
    const t = Date.now() + 14 * 864e5;
    window.localStorage.setItem(KEY, String(t));
    return t;
  });
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, []);
  const diff = Math.max(0, deadline - now);
  const d = Math.floor(diff / 864e5);
  const h = Math.floor((diff % 864e5) / 36e5);
  const m = Math.floor((diff % 36e5) / 6e4);
  const s = Math.floor((diff % 6e4) / 1000);
  return { d, h, m, s };
}

function RotatingUSP() {
  const [i, setI] = useState(0);
  useEffect(() => {
    const id = setInterval(
      () => setI((v) => (v + 1) % ANNOUNCEMENTS.length),
      3500
    );
    return () => clearInterval(id);
  }, []);
  return (
    <div className="relative h-4 w-[280px] md:w-[340px] overflow-hidden shrink-0">
      <AnimatePresence mode="wait">
        <motion.span
          key={i}
          data-testid="announcement-usp"
          initial={{ y: 12, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: -12, opacity: 0 }}
          transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
          className="absolute inset-0 flex items-center truncate"
        >
          <span className="inline-block w-1.5 h-1.5 rounded-full bg-[#C8A96A] mr-3 shrink-0" />
          <span className="truncate">{ANNOUNCEMENTS[i]}</span>
        </motion.span>
      </AnimatePresence>
    </div>
  );
}

function Countdown() {
  const { d, h, m, s } = useLaunchDeadline();
  const pad = (n) => String(n).padStart(2, "0");
  return (
    <div
      data-testid="announcement-countdown"
      className="hidden md:flex items-center gap-2 shrink-0"
    >
      <span className="text-[#C8A96A]/70">SS26 ends in</span>
      <span className="font-mono tabular-nums text-[#F4EDE2] tracking-[0.1em]">
        {d}d {pad(h)}:{pad(m)}:{pad(s)}
      </span>
    </div>
  );
}

function PromoBadge() {
  const [copied, setCopied] = useState(false);
  const copy = async () => {
    try {
      await navigator.clipboard.writeText("YABA10");
      setCopied(true);
      setTimeout(() => setCopied(false), 1600);
    } catch {
      setCopied(false);
    }
  };
  return (
    <button
      type="button"
      onClick={copy}
      data-testid="announcement-promo"
      aria-label="Copy code YABA10"
      className="hidden sm:flex items-center gap-2 shrink-0 group cursor-pointer focus:outline-none focus-visible:ring-1 focus-visible:ring-[#C8A96A] rounded-sm"
    >
      <span className="text-[#C8A96A]/70">First order</span>
      <span
        className={`relative inline-flex items-center rounded-sm px-1.5 py-0.5 tracking-[0.15em] transition-colors duration-300 ${
          copied
            ? "bg-[#F4EDE2] text-[#0C182E]"
            : "bg-[#C8A96A] text-[#0C182E] group-hover:bg-[#E9CE95]"
        }`}
      >
        <AnimatePresence mode="wait" initial={false}>
          {copied ? (
            <motion.span
              key="ok"
              initial={{ opacity: 0, y: 4 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -4 }}
              transition={{ duration: 0.2 }}
              data-testid="announcement-promo-copied"
            >
              COPIED ✓
            </motion.span>
          ) : (
            <motion.span
              key="code"
              initial={{ opacity: 0, y: 4 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -4 }}
              transition={{ duration: 0.2 }}
            >
              YABA10
            </motion.span>
          )}
        </AnimatePresence>
      </span>
      <span className="text-[#C8A96A]/70">-10%</span>
    </button>
  );
}

export function AnnouncementBar() {
  return (
    <div
      data-testid="announcement-bar"
      className="w-full bg-[#0C182E] text-[#C8A96A] text-[11px] tracking-[0.2em] uppercase"
      style={{ fontFamily: "Inter, sans-serif" }}
    >
      <div className="mx-auto max-w-[1440px] px-6 md:px-12 lg:px-20 py-2.5 flex items-center justify-between gap-4 md:gap-8">
        <RotatingUSP />
        <Countdown />
        <PromoBadge />
      </div>
    </div>
  );
}
